export const copyDivToClipboard = () => {
    let range = document.getElementById("text-field")!;
    navigator.share({
        text: range.innerText,
    });
}